/* global jQuery */

/*
 * Enable fancybox overlay popup
 */
(function ($) {
	"use strict";

	$("[data-fancybox]").fancybox({
		toolbar  : false,
		smallBtn : true,
		iframe : {
			preload : false
		}
	});

}(jQuery));

/*
 * Split full name into hidden first and last name in Marketo form
 * https://developers.marketo.com/blog/add-a-full-name-field-to-a-marketo-form/
 */

/*(function () {
	MktoForms2.whenReady(function (){
		function splitFullName(a,b,c){
			String.prototype.capitalize = function(){
				return this.replace( /(^|s)([a-z])/g , function(m,p1,p2){ return p1+p2.toUpperCase(); } );
			};
			document.getElementsByName(c)[0].oninput=function(){
				var fullName = document.getElementsByName(c)[0].value;
				var first, last;
				if((fullName.match(/ /g) || []).length ===0 || fullName.substring(fullName.indexOf(" ")+1,fullName.length) === ""){
					first = fullName.capitalize();
					last = "null";
				}else if(fullName.substring(0,fullName.indexOf(" ")).indexOf(".")>-1){
					first = fullName.substring(0,fullName.indexOf(" ")).capitalize() + " " + fullName.substring(fullName.indexOf(" ")+1,fullName.length).substring(0,fullName.substring(fullName.indexOf(" ")+1,fullName.length).indexOf(" ")).capitalize();
					last = fullName.substring(first.length +1,fullName.length).capitalize();
				}else{
					first = fullName.substring(0,fullName.indexOf(" ")).capitalize();
					last = fullName.substring(fullName.indexOf(" ")+1,fullName.length).capitalize();
				}
				document.getElementsByName(a)[0].value = first;
				document.getElementsByName(b)[0].value = last;
			};
			//Initial Values
			if(document.getElementsByName(c)[0].value.length < 2 && document.getElementsByName(b)[0].value.length.length >2 && document.getElementsByName(a)[0].value.length.length >2 ){
				var first = document.getElementsByName(a)[0].value.capitalize();
				var last = document.getElementsByName(b)[0].value.capitalize();
				var fullName =  first + " " + last ;
				console.log(fullName);
				document.getElementsByName(c)[0].value = fullName;
			}
		}
		splitFullName("FirstName","LastName","fullNameForForms");
	});
}());*/